/**
 * Location Cleaning Standards Service – real API only.
 */

import { serviceLogger } from '../utils/serviceLogger';
import * as realImpl from './real/locationCleaningStandardsService.real';

const wrap = (fnName) => async (...args) => {
  try {
    return await realImpl[fnName](...args);
  } catch (error) {
    serviceLogger.error(`[${fnName}] Error:`, error);
    throw error;
  }
};

export async function getLocationCleaningStandards(locationId) {
  if (!locationId) throw new Error('Location ID is required');
  return wrap('getLocationCleaningStandards')(locationId);
}

export async function putLocationCleaningStandards(locationId, body) {
  if (!locationId) throw new Error('Location ID is required');
  return wrap('putLocationCleaningStandards')(locationId, body);
}

export async function patchLocationCleaningStandardsDraft(locationId, body) {
  if (!locationId) throw new Error('Location ID is required');
  return wrap('patchLocationCleaningStandardsDraft')(locationId, body);
}

export async function copyLocationCleaningStandards(sourceLocationId, targetLocationIds) {
  if (!sourceLocationId) throw new Error('Source location ID is required');
  if (!targetLocationIds?.length) throw new Error('At least one target location ID is required');
  try {
    return await realImpl.copyLocationCleaningStandards(sourceLocationId, targetLocationIds);
  } catch (error) {
    serviceLogger.error('[copyLocationCleaningStandards] Error:', error);
    throw error;
  }
}
